export const RETRY_GET_DOCS_CONFIG = { delay: 3000, maxTry: 5 };
